import { isBlank } from "utils/func";

export const matches_password = (password_confirmation, formValues) => {
  const { password } = formValues;
  if (isBlank(password) || isBlank(password_confirmation)) return true;
  return password === password_confirmation || "must match password";
};
